var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("loading-box") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid-top" }, [
        _vm.mergedOptions.refresh.enabled
          ? _c(
              "div",
              {
                staticClass: "grid-item reload-btn",
                class: _vm.mergedOptions.refresh.position,
                attrs: {
                  "data-toggle": "tooltip",
                  title: _vm.resource("DataTable_Refresh_Button_Tooltip")
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("refresh")
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fas fa-sync-alt",
                  class: [_vm.loading ? "fa-spin" : ""]
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.mergedOptions.filter.enabled,
                expression: "mergedOptions.filter.enabled"
              }
            ],
            staticClass: "grid-item right",
            class: _vm.mergedOptions.filter.position
          },
          [
            _c("datatable-filter", {
              ref: "filter",
              staticClass: "table-filter",
              on: {
                filter: function($event) {
                  return _vm.filter($event)
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-item" }, [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", {
              ref: "table",
              staticClass: "dt-responsive display nowrap dataTable dtr-inline",
              class: (_vm.datatableClasses || []).concat(
                [_vm.loading ? "loading-results" : ""],
                [_vm.isCollapsed ? "collapsed" : ""]
              ),
              attrs: { id: _vm.elementId },
              nativeOn: {
                click: function($event) {
                  return _vm.tableClicked($event)
                }
              }
            })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }